import { useState } from 'react'
import { supabase } from '@/lib/supabase'
import { classFromDb, classToDb } from '@/lib/mappers'

export function useClasses(activeTermId, userId) {
  const [classes, setClasses] = useState([])

  async function loadClasses(termId) {
    const { data } = await supabase.from('classes').select('*').eq('term_id', termId)
    const mapped = (data || []).map(classFromDb)
    setClasses(mapped)
    return mapped
  }

  async function addClass(cls) {
    setClasses(prev => [...prev, cls])
    if (activeTermId) {
      const { error } = await supabase.from('classes').insert(classToDb(cls, activeTermId, userId))
      if (error) console.error('Failed to add class:', error)
    }
  }

  async function updateClass(classId, updates) {
    setClasses(prev => prev.map(c => c.id === classId ? { ...c, ...updates } : c))
    if (activeTermId) {
      const dbUpdates = {}
      if (updates.name !== undefined) dbUpdates.name = updates.name
      if (updates.startTime !== undefined) dbUpdates.start_time = updates.startTime
      if (updates.duration !== undefined) dbUpdates.duration = updates.duration
      if (updates.days !== undefined) dbUpdates.days = updates.days
      if (updates.location !== undefined) dbUpdates.location = updates.location
      if (updates.professor !== undefined) dbUpdates.professor = updates.professor
      if (updates.notes !== undefined) dbUpdates.notes = updates.notes
      await supabase.from('classes').update(dbUpdates).eq('id', classId).eq('term_id', activeTermId)
    }
  }

  async function deleteClass(classId) {
    setClasses(prev => prev.filter(c => c.id !== classId))
    if (activeTermId) {
      await supabase.from('classes').delete().eq('id', classId).eq('term_id', activeTermId)
    }
  }

  function clearClasses() {
    setClasses([])
  }

  return {
    classes,
    _setClassesRaw: setClasses,
    loadClasses,
    addClass,
    updateClass,
    deleteClass,
    clearClasses,
  }
}
